import { useEffect, useRef, useState } from "react";
import "./AmbientAudio.css";
import { useTranslation } from "react-i18next";

const AmbientAudio = () => {
  const { t } = useTranslation();
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const [playing, setPlaying] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem("kujipy-audio");
    if (saved === "on" && audioRef.current) {
      audioRef.current.volume = 0.15;
      audioRef.current.play().then(() => setPlaying(true)).catch(() => {
        localStorage.setItem("kujipy-audio", "off");
        setPlaying(false);
      });
    }
  }, []);

  const toggleAudio = () => {
    if (!audioRef.current) return;

    if (playing) {
      audioRef.current.pause();
      localStorage.setItem("kujipy-audio", "off");
    } else {
      audioRef.current.volume = 0.15;
      audioRef.current.play().then(() => {
        localStorage.setItem("kujipy-audio", "on");
        setPlaying(true);
      }).catch(() => setPlaying(false));
      return;
    }

    setPlaying(!playing);
  };

  return (
    <div className="ambient-audio">
      <audio ref={audioRef} loop>
        <source src="/audio/fondoKujipy.mp3" type="audio/mpeg" />
      </audio>

      <button
        onClick={toggleAudio}
        aria-label={playing ? t("common.pauseSound") : t("common.listenSound")}
        className="ambient-audio-button"
      >
        <span className="ambient-audio-icon" aria-hidden="true">{playing ? "❚❚" : "♪"}</span>

        <span className="ambient-audio-label">
          {playing ? t("common.pauseSound") : t("common.listenSound")}
        </span>
      </button>
    </div>
  );
};

export default AmbientAudio;
